const AppContext = {
  keycloakConfig: `${process.env.PUBLIC_URL}/assets/config/${process.env.REACT_APP_KEYCLOAK_FILE_NAME}`,
  baseUrl:
    process.env.REACT_APP_API_BASE_URL ||
    "https://api.loyaltybeta.cxforge.com/api/",
};

export default AppContext;
